import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, display, m, mb, mh, mr, p} from "@pg-design/helpers-css";
import {CheckIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IBlogCardProps {
    className?: string;
    children: React.ReactNode;
    target?: "_self" | "_blank";
    href: string;
}

export const BlogCard = (props: IBlogCardProps) => {
    const target = useResponsiveLinkTarget();
    return (
        <BlogCardBase target={target} href={props.href} className={props.className}>
            {props.children}
        </BlogCardBase>
    );
};

const BlogCardBase = styled.a`
    cursor: pointer;
    ${mh("auto")};

    &:hover,
    &:focus,
    &.focus,
    &:active,
    &.active,
    &:active:hover,
    &.active:hover,
    &:active:focus,
    &.active:focus,
    &:active.focus,
    &.active.focus {
        color: ${(props) => props.theme.colors.secondary};
    }
`;

const BlogCardBody: React.FC<{children: React.ReactNode; className?: string}> = (props) => (
    <div css={blogCardBody} className={props.className}>
        {props.children}
    </div>
);
BlogCard.Body = BlogCardBody;

type IPictureProps = React.ComponentProps<typeof Picture>;
const CardPicture = (props: IPictureProps) => <Picture {...props} css={cardPicture} />;
BlogCard.Picture = CardPicture;

const HeaderText: React.FC<{children: React.ReactNode}> = (props) => (
    <Text as="p" variant="headline_2" fontFamily="secondary" css={p(2)}>
        {props.children}
    </Text>
);

BlogCard.Header = HeaderText;

const SubheaderText: React.FC<{children: React.ReactNode; className?: string}> = (props) => (
    <Text as="p" variant="headline_6" css={cardSubHeader} className={props.className}>
        <span css={cardSubHeaderText}>{props.children}</span>
    </Text>
);

BlogCard.SubHeader = SubheaderText;

const CheckList = (props: {items: string[]}) => (
    <ul css={p(0, 1, 2, 2)}>
        {props.items.map((item) => (
            <Text key={item} as="span" variant="body_copy_2" css={[mb(2), display("block")]}>
                <CheckIcon size="1.7" css={mr(1)} />
                {item}
            </Text>
        ))}
    </ul>
);

BlogCard.CheckList = CheckList;

const BulletList = (props: {items: string[]}) => (
    <ul css={[p(0, 0, 4, 5), m(0)]}>
        {props.items.map((item) => (
            <Text key={item} as="li" variant="body_copy_1">
                {item}
            </Text>
        ))}
    </ul>
);

BlogCard.BulletList = BulletList;

const NextIcon = () => (
    <ChevronRightIcon
        css={css`
            margin-left: auto;
            position: absolute;
            bottom: 1.6rem;
            right: 2.6rem;
        `}
        wrapperColor="#EBFF00"
        size="1.6"
        wrapperSize="3.2"
    />
);
BlogCard.NextIcon = NextIcon;

const BlogCardButton: React.FC<{children: React.ReactNode}> = (props) => (
    <Button variant="outlined_secondary" css={m(0, 0, 2, 2)}>
        {props.children}
    </Button>
);
BlogCard.Button = BlogCardButton;

const cardPicture = css`
    ${borderRadius(2, 2, 0, 0)};
    overflow: hidden;
`;

const blogCardBody = css`
    display: block;
    ${borderRadius(2)};
    ${elevation(2)};
    position: relative;
    background-color: #fff;
    cursor: pointer;
    ${mh("auto")};
`;

const cardSubHeader = css`
    ${p(2)};
    ${mb(2)};
`;

const cardSubHeaderText = css`
    display: inline-block;
    @media (min-width: ${getThemeBreakpoint().md}) {
        min-height: ${calculateRemSize(6)};
    }
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, display, m, mb, mh, mr, p} from "@pg-design/helpers-css";
import {CheckIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {Picture} from "@pg-design/picture-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";

interface IBlogCardProps {
    className?: string;
    children: React.ReactNode;
    target?: "_self" | "_blank";
    href: string;
}

export const BlogCard = (props: IBlogCardProps) => {
    const target = useResponsiveLinkTarget();
    return (
        <BlogCardBase target={target} href={props.href} className={props.className}>
            {props.children}
        </BlogCardBase>
    );
};

const BlogCardBase = styled.a`
    cursor: pointer;
    ${mh("auto")};

    &:hover,
    &:focus,
    &.focus,
    &:active,
    &.active,
    &:active:hover,
    &.active:hover,
    &:active:focus,
    &.active:focus,
    &:active.focus,
    &.active.focus {
        color: ${(props) => props.theme.colors.secondary};
    }
`;

const BlogCardBody: React.FC<{children: React.ReactNode; className?: string}> = (props) => (
    <div css={blogCardBody} className={props.className}>
        {props.children}
    </div>
);
BlogCard.Body = BlogCardBody;

type IPictureProps = React.ComponentProps<typeof Picture>;
const CardPicture = (props: IPictureProps) => <Picture {...props} css={cardPicture} />;
BlogCard.Picture = CardPicture;

const HeaderText: React.FC<{children: React.ReactNode}> = (props) => (
    <Text as="p" variant="headline_2" fontFamily="secondary" css={p(2)}>
        {props.children}
    </Text>
);

BlogCard.Header = HeaderText;

const SubheaderText: React.FC<{children: React.ReactNode; className?: string}> = (props) => (
    <Text as="p" variant="headline_6" css={cardSubHeader} className={props.className}>
        <span css={cardSubHeaderText}>{props.children}</span>
    </Text>
);

BlogCard.SubHeader = SubheaderText;

const CheckList = (props: {items: string[]}) => (
    <ul css={p(0, 1, 2, 2)}>
        {props.items.map((item) => (
            <Text key={item} as="span" variant="body_copy_2" css={[mb(2), display("block")]}>
                <CheckIcon size="1.7" css={mr(1)} />
                {item}
            </Text>
        ))}
    </ul>
);

BlogCard.CheckList = CheckList;

const BulletList = (props: {items: string[]}) => (
    <ul css={[p(0, 0, 4, 5), m(0)]}>
        {props.items.map((item) => (
            <Text key={item} as="li" variant="body_copy_1">
                {item}
            </Text>
        ))}
    </ul>
);

BlogCard.BulletList = BulletList;

const NextIcon = () => (
    <ChevronRightIcon
        css={css`
            margin-left: auto;
            position: absolute;
            bottom: 1.6rem;
            right: 2.6rem;
        `}
        wrapperColor="#EBFF00"
        size="1.6"
        wrapperSize="3.2"
    />
);
BlogCard.NextIcon = NextIcon;

const BlogCardButton: React.FC<{children: React.ReactNode}> = (props) => (
    <Button variant="outlined_secondary" css={m(0, 0, 2, 2)}>
        {props.children}
    </Button>
);
BlogCard.Button = BlogCardButton;

const cardPicture = css`
    ${borderRadius(2, 2, 0, 0)};
    overflow: hidden;
`;

const blogCardBody = css`
    display: block;
    ${borderRadius(2)};
    ${elevation(2)};
    position: relative;
    background-color: #fff;
    cursor: pointer;
    ${mh("auto")};
`;

const cardSubHeader = css`
    ${p(2)};
    ${mb(2)};
`;

const cardSubHeaderText = css`
    display: inline-block;
    @media (min-width: ${getThemeBreakpoint().md}) {
        min-height: ${calculateRemSize(6)};
    }
`;
